import { Component, OnInit, Input } from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {LocalDataSource} from 'ng2-smart-table';
import Swal, {SweetAlertIcon} from 'sweetalert2';
import {FirebaseStorageService} from '../../services/firebase-storage.service';
import {SasisopaService} from '../../services/sasisopa.service';
import {SassisopaFormatsService} from '../../services/sassisopa-formats.service';
import {StationService} from '../../services/stations.service';
import {NbDialogService} from '@nebular/theme';
import {v4 as uuidv4} from 'uuid';
import { finalize, filter } from 'rxjs/operators';
import * as moment from 'moment';
import { ValidateOpenDetailComponent } from './validate-open-detail/validate-open-detail.component';

const Lockr = require('lockr');

@Component({
  selector: 'ngx-documents-sasisopa',
  templateUrl: './documents.component.html',
  styleUrls: ['./documents.component.scss'],
})
export class DocumentsComponent implements OnInit {
  @Input() stationId: string;
  @Input() procedure: number = 0;
  isActive = false;
  loading = false;
  data = {
    name: '',
    custom_procedure: null,
    procedure_number: 0,
    url_image: 'https://cdn-icons-png.flaticon.com/512/3286/3286271.png',
  };
  formats: any = [];
  item = {id: 0, name: '', code: ''};
  files: any = [];
  sourceData: LocalDataSource;
  downloadURLs = [];
  dataForManager = {documents: [], id: 0, type: 'document', name: '', uploadPath: ''};
  settings: any = {
    mode: 'external',
    actions: {
      columnTitle: '',
      position: 'right',
      add: false,
      edit: false,
      delete: false,
      custom: [
        {
          name: 'edit',
          title: '<img src="assets/images/icons/edit.svg" class="mx-1 hover-cursor-pointer" width="35px">',
        },
        {
          name: 'delete',
          title: '<img src="assets/images/icons/delete.svg" class="mr-1 hover-cursor-pointer" width="35px">',
        },
        {name: 'folder', title: '<img src="assets/images/icons/folder.svg" class="hover-cursor-pointer" width="35px">'},
        {
          name: 'detail',
          title: '<img src="assets/images/icons/next.svg" class="hover-cursor-pointer mx-1" width="35px">',
        },
      ],
    },
    pager: {perPage: 15},
    columns: {
      name: {title: 'Nombre', filter: true},
      code: {title: 'Código', filter: true},
      attacheds: {title: '# Archivos', filter: true, valuePrepareFunction: (attacheds) => attacheds.length},
      created_at: {
        title: 'Fecha de creación',
        filter: true,
        valuePrepareFunction: (created) => moment(created).format('ll'),
      },
    },
    noDataMessage: 'Sin registros',
  };
  settings_implementation: any = {
    mode: 'external',
    actions: false,
    columns: {
      name: {title: 'Nombre', filter: true},
      code: {title: 'Código', filter: true},
      actions: {
        add: false,
        edit: false,
        delete: false,
        filter: false,
        title: '',
        type: 'custom',
        valuePrepareFunction: (cell, row) => row,
        renderComponent: ValidateOpenDetailComponent,
        onComponentInitFunction: (instance) => {
          instance.openDetail.subscribe(event => {
            this.onCustomImplementation(event);
          });
        },
      },
    },
    pager: {perPage: 15},
    noDataMessage: 'Sin registros',
  };

  constructor(
    private stationService: StationService,
    private route: ActivatedRoute,
    private sasisopaService: SasisopaService,
    private firebaseStorageService: FirebaseStorageService,
    public router: Router,
  ) {
  }

  ngOnInit() {
    const activateTab = Lockr.get('activateTab');
    if (activateTab) {
      this.isActive = true;
    } else {
      this.isActive = false;
    }
    this.stationService.checkIfStationIdOrRefirect();
    this.getDocuments();
    this.getProcedureFormats();
    Lockr.rm('activateTab');
  }

  async loadImage(event: any) {
    if (!event.target.files.length) return;
    this.loading = true;
    for await (const image of event.target.files) {
      const reader = new FileReader();
      await reader.readAsDataURL(image);
      this.files.push(image);
      this.loading = false;
    }
  }

  async getDocuments() {
    this.loading = true;
    const [error, response] = await this.sasisopaService.getDocumentsByStationIdAndProcedureId(this.stationId, this.procedure);
    this.loading = false;
    if (error) return this.alert('Error', 'error', 'Oops... ocurrio algo, intenta mas tarde');
    this.data = response.data;
    this.sourceData = response.data.documents;
  }

  onCustom($event) {
    if ($event.action === 'edit') {
      this.item = $event.data;
      // @ts-ignore
      $('#edit-document').modal('show');
    } else if ($event.action === 'delete') {
      this.item = $event.data;
      // @ts-ignore
      $('#delete-document').modal('show');
    } else if ($event.action === 'folder') {
      this.dataForManager.id = $event.data.id;
      this.dataForManager.documents = $event.data.attacheds;
      this.dataForManager.name = $event.data.name;
      this.dataForManager.uploadPath = `images/sasisopa/${this.stationId}/procedimiento${this.route.snapshot.params.procedureId}`;
      // @ts-ignore
      $('#modal-manager-files-sasisopa').modal('show');
    } else if ($event.action === 'detail') {
      // implementacion-sasisopa/:stationId/procedimiento/:procedureId/document/:documentId/detail
      this.router.navigate(['/pages/implementacion-sasisopa', this.stationId, 'procedimiento', this.route.snapshot.params.procedureId, 'documento', $event.data.id, 'detalle']);
    }
  }

  onCustomImplementation(rowData: { id: number, name: string, code: string; fileDownload?: boolean; completed: boolean; }) {
    const code = rowData.code;
    if (rowData.fileDownload) {
      this.router.navigate(['/pages/implementacion-sasisopa', this.stationId, 'procedimiento', this.route.snapshot.params.procedureId, 'formato', code, 'detalle'], { queryParams: { fileDownload: 'true' } });
      return;
    }
    this.router.navigate(['/pages/implementacion-sasisopa', this.stationId, 'procedimiento', this.route.snapshot.params.procedureId, 'formato', code, 'detalle']);
  }

  async update() {
    this.loading = true;
    const [error] = await this.sasisopaService.updateDocument(this.item.id, this.item);
    if (error) return this.alert('Error', 'error', 'Oops... ocurrio algo, intenta mas tarde');
    this.loading = false;
    // @ts-ignore
    $('#edit-document').modal('hide');
    this.getDocuments();
    return this.alert('Éxito', 'success', 'Se édito el documento');
  }

  async store() {
    this.loading = true;
    const [error, response] = await this.sasisopaService.storeDocument(this.stationId, this.route.snapshot.params.procedureId, this.item);
    if (error) return this.alert('Error', 'error', 'Oops... ocurrio algo, intenta mas tarde');
    if (!this.files.length) {
      this.loading = false;
      // @ts-ignore
      $('#create-document').modal('hide');
      this.getDocuments();
      this.item = {id: 0, name: '', code: ''};
      this.files = [];
      this.downloadURLs = [];
      return this.alert('Éxito', 'success', 'Se creo el documento');
    }
    await this.firebaseStorageService.setPath(`images/sasisopa/${this.stationId}/procedimiento${this.route.snapshot.params.procedureId}`);
    this.downloadURLs = [];
    for await (const file of this.files) {
      const filename = uuidv4();
      const fileRef = await this.firebaseStorageService.referenceCloudStorage(filename);
      const task = this.firebaseStorageService.taskCloudStorage(filename, file);
      // get notified when the download URL is available
      task.snapshotChanges().pipe(
        finalize(() => {
          fileRef.getDownloadURL().subscribe(async (url) => {
            this.downloadURLs = this.downloadURLs.concat([url]);
            if (this.files.length === this.downloadURLs.length) {
              const [err] = await this.sasisopaService.uploadImage(this.stationId, {
                type: 'document',
                type_id: response.data.id,
                urls: this.downloadURLs,
              });
              if (err) return this.alert('Oops, ocurrio un error al cargar el archivo', 'error');
              // @ts-ignore
              $('#create-document').modal('hide');
              this.getDocuments();
              this.alert('Éxito', 'success', 'Se creo el documento');
              this.item = {id: 0, name: '', code: ''};
              this.files = [];
              this.downloadURLs = [];
              this.loading = false;
            }
          });
        }),
      ).subscribe();
    }
  }

  async deleteDocument() {
    this.loading = true;
    const [error] = await this.sasisopaService.deleteDocument(this.item.id);
    if (error) return this.alert('Error', 'error', 'Oops... ocurrio algo, intenta mas tarde');
    this.loading = false;
    // @ts-ignore
    $('#delete-document').modal('hide');
    this.getDocuments();
    return this.alert('Éxito', 'success', 'Se elimino el documento');
  }

  async delete(index: number) {
    this.files.splice(index, 1);
  }

  alert(title: string = 'asdasd', type: SweetAlertIcon = 'success', text: string = '') {
    return Swal.fire({
      icon: type,
      title: title,
      text: text,
    });
  }

  getProcedureFormats() {
    if (this.route.snapshot.params.procedureId === '1') {
      this.formats = [
        {
          id: 1,
          name: 'FORMATO: POLÍTICA',
          code: 'FOR-P1-01',
          completed: true
        },
      ];
    }
    if (this.route.snapshot.params.procedureId === '2') {
      this.formats = [
        {
          id: 1,
          name: 'FORMATO: MATRIZ DE COMUNICACIÓN',
          code: 'FOR-P7-01',
          completed: false
        },
        {
          id: 2,
          name: 'FORMATO: ACTOS Y CONDICIONES INSEGURAS DE TRABAJO Y/O QUE PUEDEN DAÑAR EL MEDIO AMBIENTE',
          code: 'FOR-P7-02',
          completed: false
        },
      ];
    }
    if (this.route.snapshot.params.procedureId === '4') {
      this.formats = [
        {
          id: 1,
          name: 'FORMATO: DISEÑO Y ESTABLECIMIENTO DE OBJETIVOS, METAS E INDICADORES',
          code: 'FOR-P4-01',
          completed: true
        },
      ];
    }
    if (this.route.snapshot.params.procedureId === '5') {
      this.formats = [
        {
          id: 1,
          name: 'FORMATO: ORGANIGRAMA',
          code: 'FOR-P5-01',
          completed: false
        },
        {
          id: 2,
          name: 'FORMATO: DESIGNACIÓN DEL REPRESENTANTE TÉCNICO',
          code: 'FOR-P5-02',
          fileDownload: true,
          completed: true
        },
        {
          id: 3,
          name: 'FORMATO: SOLICITUD DE RECURSOS',
          code: 'FOR-P5-03',
          completed: true
        },
      ];
    }
    if (this.route.snapshot.params.procedureId === '6') {
      this.formats = [
        {
          id: 1,
          name: 'FORMATO: PERFIL DEL PUESTO',
          code: 'FOR-P6-01',
          completed: true
        },
        {
          id: 2,
          name: 'FORMATO: LISTA DE VERIFICACIÓN PARA DETECCIÓN DE NECESIDADES DE CAPACITACIÓN',
          code: 'FOR-P6-02',
          completed: true
        },
        {
          id: 3,
          name: 'FORMATO: PROGRAMA DE INDUCCIÓN, CAPACITACIÓN Y ENTRENAMIENTO.',
          code: 'FOR-P6-03',
          completed: true
        },
        {
          id: 4,
          name: 'FORMATO: EVALUACIÓN DE LA CAPACITACIÓN Y/O ENTRENAMIENTO',
          code: 'FOR-P6-04',
          completed: false
        },
        {
          id: 5,
          name: 'FORMATO: REGISTRO DE COMPETENCIAS',
          code: 'FOR-P6-05',
          completed: true
        },
      ];
    }
    if (this.route.snapshot.params.procedureId === '7') {
      this.formats = [
        {
          id: 1,
          name: 'FORMATO: MATRIZ DE COMUNICACIÓN',
          code: 'FOR-P7-01',
          type: 'cloud',
          completed: true
        },
        {
          id: 2,
          name: 'FORMATO: ACTOS Y CONDICIONES INSEGURAS DE TRABAJO Y/O QUE PUEDEN DAÑAR EL MEDIO AMBIENTE',
          code: 'FOR-P7-02',
          type: 'implementation',
          fileDownload: true,
          completed: true
        },
        {
          id: 3,
          name: 'FORMATO: REGISTRO DE SOLICITUDES, NECESIDADES DE INFORMACIÓN, QUEJAS O SUGERENCIAS',
          code: 'FOR-P7-03',
          fileDownload: true,
          completed: true
        },
        {
          id: 4,
          name: 'FORMATO: SEGUIMIENTO DE ATENCIÓN',
          code: 'FOR-P7-04',
          completed: true
        },
        {
          id: 5,
          name: 'FORMATO: LISTA DE ASISTENCIA Y COMUNICACIÓN DE INFORMACIÓN',
          code: 'FOR-P7-05',
          fileDownload: true,
          completed: true
        },
      ];
    }
    if (this.route.snapshot.params.procedureId === '8') {
      this.formats = [
        {
          id: 1,
          name: 'FORMATO: CREACIÓN O MODIFICACIÓN',
          code: 'FOR-P8-01',
          type: 'cloud',
          completed: false
        },
        {
          id: 2,
          name: 'FORMATO: LISTA MAESTRA',
          code: 'FOR-P8-02',
          type: 'implementation',
          completed: false,
        },
        {
          id: 3,
          name: 'FORMATO: CARTA DE CONFIDENCIALIDAD',
          completed: true,
          code: 'FOR-P8-03',
        },
        {
          id: 4,
          name: 'FORMATO: CONTROL DE DOCUMENTOS EXTERNOS',
          completed: true,
          code: 'FOR-P8-04',
        },
      ];
    }
    if (this.route.snapshot.params.procedureId === '9') {
      this.formats = [
        {
          id: 1,
          name: 'FORMATO: IDENTIFICACIÓN DE MEJORES PRÁCTICAS Y ESTÁNDARES',
          code: 'FOR-P9-01',
          completed: true,
        },
      ];
    }
    if (this.route.snapshot.params.procedureId === '10') {
      this.formats = [
        {
          id: 1,
          name: 'FORMATO: CONTROLES OPERACIONALES',
          code: 'FOR-P10-01',
          completed: true,
        },
      ];
    }
    if (this.route.snapshot.params.procedureId === '11') {
      this.formats = [
        {
          id: 1,
          name: 'FORMATO: PROGRAMA ANUAL DE MANTENIMIENTO',
          code: 'FOR-P11-01',
          completed: true,
        },
        {
          id: 2,
          name: 'FORMATO: EQUIPOS CRÍTICOS',
          code: 'FOR-P11-02',
          completed: true,
        },
        {
          id: 3,
          name: 'FORMATO: CONTROL DE REGISTROS Y CAMBIOS',
          code: 'FOR-P11-03',
          completed: true,
        },
      ];
    }
    if (this.route.snapshot.params.procedureId === '12') {
      this.formats = [
        {
          id: 1,
          name: 'FORMATO: CARTA RESPONSIVA',
          code: 'FOR-P12-01',
          completed: true,
        },
        {
          id: 2,
          name: 'FORMATO: REQUISITOS DEL SASISOPA PARA CONTRATISTAS, SUBCONTRATISTAS, PRESTADORES DE SERVICIO Y PROVEDORES',
          code: 'FOR-P12-02',
          completed: true,
        },
        {
          id: 3,
          name: 'FORMATO: CONTRATISTAS APROBADOS',
          code: 'FOR-P12-03',
          completed: true,
        },
        {
          id: 4,
          name: 'FORMATO: PERMISOS DE TRABAJO DE ALTO RIESGO',
          code: 'FOR-P12-04',
          completed: false,
        },
      ];
    }
    if (this.route.snapshot.params.procedureId === '13') {
      this.formats = [
        {
          id: 1,
          name: 'FORMATO: PLAN DE ATENCIÓN A EMERGENCIAS',
          completed: true,
          code: 'FOR-P13-01',
        },
        {
          id: 2,
          name: 'FORMATO: DISPONIBILIDAD DE RECURSOS',
          completed: true,
          code: 'FOR-P13-02',
        },
        {
          id: 3,
          name: 'FORMATO: CONFORMACIÓN DE BRIGADAS',
          completed: true,
          code: 'FOR-P13-03',
        },
        {
          id: 4,
          name: 'FORMATO: NÚMEROS DE EMERGENCIA',
          completed: true,
          code: 'FOR-P13-04',
        },
      ];
    }
    if (this.route.snapshot.params.procedureId === '14') {
      this.formats = [
        {
          id: 2,
          name: 'FORMATO: GESTIÓN DE HALLAZGOS',
          completed: true,
          code: 'FOR-P14-02',
        },
      ];
    }
    if (this.route.snapshot.params.procedureId === '15') {
      this.formats = [
        {
          id: 1,
          name: 'FORMATO: PROGRAMA DE AUDITORÍAS',
          completed: true,
          code: 'FOR-P15-01',
        },
        {
          id: 2,
          name: 'FORMATO: PLAN DE AUDITORÍA',
          completed: true,
          code: 'FOR-P15-02',
        },
        {
          id: 3,
          name: 'FORMATO: INFORME DE AUDITORÍA',
          completed: true,
          code: 'FOR-P15-03',
        },
      ];
    }
    if (this.route.snapshot.params.procedureId === '16') {
      this.formats = [
        {
          id: 1,
          name: 'PROGRAMA DE ACTIVIDADES DE INVESTIGACIONES CAUSA RAÍZ',
          completed: true,
          code: 'FOR-P16-01',
        },
      ];
    }
    if (this.route.snapshot.params.procedureId === '17') {
      this.formats = [
        {
          id: 1,
          name: 'FORMATO: REVISIÓN DE RESULTADOS',
          completed: true,
          code: 'FOR-P17-01',
        },
        {
          id: 2,
          name: 'FORMATO: INFORME DE RESULTADOS',
          completed: true,
          code: 'FOR-P17-02',
        }
      ];
    }
  }
}
